<template>
    <div class="rhythmClass">
        <div class="imgStyleUrlBox" v-if="heart.questionDto.detailInfo.questionImgUrl">
            <viewer>
                <img class="imgStyleUrl" :src="heart.questionDto.detailInfo.questionImgUrl" alt="" srcset="">
            </viewer>
        </div>
        <el-col :span="24" class="zhiAudio" align="left" v-if="heart.questionDto.detailInfo.audioUrl">
            <audio-style 
                style="width:180px;float:left;"
                ref="audioRef"
                @startPlaying="startPlaying"
                @endPlaying="endPlaying"
                @getPlays="getPlays"
                :styleText="'请点击播放'"
                :audioUrl="heart.questionDto.detailInfo.audioUrl"
                class="audioCom"
            ></audio-style>
            <div class="playNum" v-if="heart.audioPlayTime!=-1">
                <div class="playNumIng"><img src="./../../../static/images/play.png" alt="" srcset=""></div>
                {{`X${plays}`}}
            </div>
        </el-col>
        <el-col :span="24" class="explainText" v-if="heart.questionDto.detailInfo.audioUrl">
            点击音频部分播放打谱
        </el-col>
        <el-col :span="24" :class="['imgStyle',{'isYImg':heart.questionDto.detailInfo.questionImgUrl,'isYAudio':heart.questionDto.detailInfo.audioUrl}]" align="left">
            <el-button type="text" class="aginOnce" @click="resetLine">重置</el-button>
            <div style="clear:both;"></div>
            <!-- 连线 -->
            <div class="optionsHaveValue" :id="`diagramContainer${serial}`" style="position: relative;">
                
                <div class="optionLeft">
                    <div v-for="(temp,index) in leftList" :key="index" :id="`anXx${index}_${serial}`" class="leftSpec hybrid">
                        <viewer v-html="temp.msgText"></viewer>
                    </div>
                </div>

                <div class="optionRight">
                    <div v-for="(temp,index) in rightList" :key="index" :id="`mXx${index}_${serial}`" class="rightSpec hybrid">
                        <viewer v-html="temp.msgText"></viewer>
                    </div>
                </div>

            </div>
        </el-col>

    </div>
</template>
<script>
import utils from '../../lib/util'
import wsMethod from '../../lib/socketMethod'
import audioStyle from '../../components/audioStyle'
    export default {
        name:"connectionLine91",
        props: {
            sonData: Object,
            allAnswer: Object,
            serial:Number,
            buttonNum:Number,
            allData:Object,
        },
        data() {
            return {
                heart:{
                    questionDto:{
                        detailInfo:{}
                    }
                },
                leftList:[],
                rightList:[],
                valLine:[],
                connectVal:'',
                timeHer:'',
                plays:0,
                answerType:null,
                uid:this.$base64.decode(window.localStorage.getItem('uid-web')),
                common:{
                    isSource: true,
                    isTarget: true,
                    connector: 'Straight',
                    maxConnections: -1,
                    endpoint: ['Dot', {
                        radius: 8,
                        fill: '#ff5722'
                    }],
                    endpointStyle : { fill : "#fff",outlineStroke: 'blue',},
                    paintStyle: {
                        fill: 'white',
                        outlineStroke: 'blue',
                        strokeWidth: 1
                    },
                    hoverPaintStyle: {
                        outlineStroke: 'lightblue'
                    },
                    connectorStyle: {
                        outlineStroke: '#134DBA',
                        strokeWidth: 1
                    },
                    connectorHoverStyle: {
                        strokeWidth: 1
                    },
                }
            }
        },
        components:{
            audioStyle
        },
        watch: {
            'connectVal':function(now,old){
                if(now&&this.answerType)this.answerType=null
                this.$emit('storeLocally')
            },
            'buttonNum':function(now,old){
                if(now==this.serial){
                    this.$nextTick(()=>{
                        this.jsCanvasLoc(this)

                        // 赋值答案
                        let loc = localStorage.getItem('ceping-'+this.uid+'-'+this.allData.bId)? JSON.parse(localStorage.getItem('ceping-'+this.uid+'-'+this.allData.bId)):''
                        let ls = loc? loc.dataList[this.serial-1].obj.connectVal:''
                        
                        if(ls){
                            this.connectVal =  ls
                            
                            this.huaxian(JSON.parse(ls))
                        }
                    })
                }else{
                    this.$emit('storeLocally')
                    this.$jsPlumb.deleteEveryConnection();
                    this.$jsPlumb.deleteEveryEndpoint()
                }
            },
            'answerType':function(now,old){
                this.$emit('storeLocally')
            },
        },
        beforeDestroy(){
            this.$jsPlumb.deleteEveryEndpoint()
            this.$jsPlumb.deleteEveryConnection()
        },
        computed:{},
        created(){},
        mounted(){
            this.heart = this.sonData
            this.$nextTick(function(){
                this.rhythmBeatVal0 = []
                if(this.heart.questionDto.detailInfo&&this.heart.questionDto.detailInfo.list.length>0){
                    let reg = /<div(([\s\S])*?)<\/div>/gi;
                    this.leftList = this.heart.questionDto.detailInfo.left.map((item)=>{
                        item['msgText'] = utils.dealText(item.msg.replace(/\\n/g,'<br>'))
                        return item
                    })
                    this.rightList = this.heart.questionDto.detailInfo.right.map((item)=>{
                        // item['msgText'] = utils.dealText(item.msg).replace(reg,'')
                        item['msgText'] = utils.dealText(item.msg.replace(/\\n/g,'<br>'))
                        return item
                    })

                    this.$nextTick(()=>{
                        if(this.buttonNum == this.serial){
                            this.jsCanvasLoc(this)
                        }

                        // 赋值答案
                        if(this.allAnswer){
                            if(this.buttonNum==this.serial && this.allAnswer.obj.connectVal){
                                this.huaxian(JSON.parse(this.allAnswer.obj.connectVal))
                            }
                            this.connectVal = this.allAnswer.obj.connectVal
                            this.answerType = this.allAnswer.obj.answerType
                        }
                    })
                }
            })
        },
        methods:{
            jsCanvasLoc(that){
                that.$jsPlumb.ready(function () {
                    that.$jsPlumb.setContainer(`diagramContainer${that.serial}`)
                    that.$jsPlumb.importDefaults({
                        ConnectionsDetachable: false
                    })
                    
                    for (let i = 0; i < that.leftList.length; i++) {
                        that.$jsPlumb.addEndpoint(`anXx${i}_${that.serial}`, {
                            anchors: ['Right'],
                        }, that.common) 
                    }
                    for (let c = 0; c < that.rightList.length; c++) {
                        that.$jsPlumb.addEndpoint(`mXx${c}_${that.serial}`, {
                            anchors: ['Left'],
                        }, that.common)
                    }
                })
                // 当链接建立前
                that.$jsPlumb.bind('beforeDrop', function (info) {
                    if(info.sourceId.substr(0,1) == info.targetId.substr(0,1)){
                        that.$message({showClose: true,message: `连接失败`})
                        return false
                    }else{
                        that.$nextTick(()=>{
                            that.statistical()
                        })
                        return true // 链接会自动建立
                    }
                })
            },
            statistical(){
                this.$set(this,'valLine',[])
                // 获取JsPlumb对象内所有线数据
                var connections = this.$jsPlumb.getAllConnections();
                if(!connections){
                    this.connectVal = ''
                    return
                }

                for (let zo = 0; zo < this.leftList.length; zo++) {
                    const eln = this.leftList[zo];
                    for(var i in connections){
                        
                        if(`anXx${zo}_${this.serial}`==connections[i].sourceId){

                            this.valLine.push({
                                "selectId":eln.bId,
                                "answerIds":this.rightList[connections[i].targetId.replace('mXx','').split('_')[0]].bId,
                            })
                            continue;
                        }else if(`anXx${zo}_${this.serial}`==connections[i].targetId){
                            this.valLine.push({
                                "selectId":eln.bId,
                                "answerIds":this.rightList[connections[i].sourceId.replace('mXx','').split('_')[0]].bId,
                            })
                            continue;
                        }
                    }
                }

                this.connectVal = ''
                if(this.serial == connections[i].sourceId.split('_')[1] && this.valLine.length>0){

                    let temp = {};
                    for (let i in this.valLine) {
                        let key = this.valLine[i].selectId; //判断依据
                        if (temp[key]) {
                            temp[key].selectId = this.valLine[i].selectId;
                            temp[key].answerIds += `,${this.valLine[i].answerIds}`;//相加值
                        } else {
                            temp[key] = {};
                            temp[key].selectId = this.valLine[i].selectId;
                            temp[key].answerIds = this.valLine[i].answerIds;
                        }
                    }
                    let newArry = [];
                    for (var k in temp) {
                        newArry.push(temp[k]);
                    }
                    this.connectVal = JSON.stringify({left:newArry})
                }
                this.$nextTick(()=>{
                    wsMethod.wsSend210(this.heart.bId,this.heart.questionId,{
                        allData:this.$parent.allData,
                        uuid1:this.$parent.uuid1,
                        firstStartDateVal:this.$parent.firstStartDateVal,
                    })
                })
            },
            huaxian(arr){
                let that = this
                // that.$jsPlumb.deleteEveryEndpoint()
                that.$nextTick(()=>{
                    if(arr.left){
                        arr.left.forEach(ele => {

                            for (let i = 0; i < that.leftList.length; i++) {
                                if(ele.selectId == that.leftList[i].bId){
                                    
                                    if(ele.answerIds){
                        
                                        let anIds = String(ele.answerIds).split(',')

                                        for (let c = 0; c < that.rightList.length; c++) {
                                            if(anIds.indexOf(String(that.rightList[c].bId))!=-1){
                                                that.goConnection(i,c)
                                            }
                                        }
                                        
                                    }
                                }
                            }
                        });
                    }
                })
            },
            goConnection(i,e){
                this.$jsPlumb.connect({
                    source: `anXx${i}_${this.serial}`, 
                    target: `mXx${e}_${this.serial}`,
                    anchors: ['Right','Left'],
                    isSource: true,
                    isTarget: true,
                    maxConnections: -1,
                },this.common)
                this.$jsPlumb.importDefaults({
                    ConnectionsDetachable: false
                })
            },
            sortData(a, b) {
                return a.answerNum - b.answerNum
            },
            resetLine(){
                for (let zo = 0; zo < this.leftList.length; zo++) {
                    const eln = this.leftList[zo];
                    this.$jsPlumb.deleteConnectionsForElement(`anXx${zo}_${this.serial}`,{});
                }
                for (let zo = 0; zo < this.rightList.length; zo++) {
                    const eln = this.rightList[zo];
                    this.$jsPlumb.deleteConnectionsForElement(`anXx${zo}_${this.serial}`,{});
                }
                this.$set(this,'connectVal','')
                this.$nextTick(()=>{
                    wsMethod.wsSend210(this.heart.bId,this.heart.questionId,{
                        allData:this.$parent.allData,
                        uuid1:this.$parent.uuid1,
                        firstStartDateVal:this.$parent.firstStartDateVal,
                    })
                })
            },
            changeAnswerType(val){
                this.answerType = val.answerType
            },
            getPlays(){
                //限定播放次数
                this.$refs.audioRef.fatherPlay(this.plays,this.heart.audioPlayTime)
            },
            startPlaying(){
                
            },
            endPlaying(){
                if(this.plays<=0) this.plays=0
                else this.plays--;
            },
            endAudio(){
                if(!this.heart.questionDto.detailInfo.audioUrl) return
                if(!this.$refs.audioRef.judgePaying()){
                    this.endPlaying()
                }
                this.$refs.audioRef.endAudio()
            },
        }
    }
</script>
<style scoped lang="less">
    .rhythmClass{
        height: 100%;
        width: 100%;
        .imgStyleUrlBox{
            height: 20%;
            max-width: 85%;
            text-align: left;
            overflow: hidden;
            .imgStyleUrl{
                max-width: 100%;
                max-height: 100%;
            }
        }
        .zhiAudio{
            height: 33px;
            width: 100%;
            box-sizing: border-box;
            padding-left: 16px;
            .playNum{
                float: left;
                display: inline-block;
                height: 33px;
                width: 100px;
                .playNumIng{
                    display: inline-block;
                    img{
                        margin: 5px 0 0 15px;
                        vertical-align: text-bottom;
                    }
                }
            }
        }
        .explainText{
            box-sizing: border-box;
            padding:5px 0 0 16px;
            text-align: left;
            font-size: 12px;
            color: #A0A1A0;
        }
        .imgStyle{
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            padding: 25px 18px;
            padding-top: 0;
            .aginOnce{
                float: right;
                height: 25px;
                line-height: 0px;
            }
            
            // 图片单选 选项非为空
            .optionsHaveValue{
                height: 100%;
                width: 100%;
                overflow: hidden;
                overflow-y: auto;
                position: relative;
                .optionLeft{
                    float: left;
                    width: 40%;
                    height: 100%;
                    .leftSpec{
                        height: 55px;
                        width: 100%;
                        margin: 5px 0;
                        border: 1px solid #004bb4;
                        border-radius: 5px;
                        overflow: hidden;
                        overflow-y: auto;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }
                }
                .optionRight{
                    float: right;
                    width: 40%;
                    height: 100%;
                    .rightSpec{
                        height: 55px;
                        width: 100%;
                        margin: 5px 0;
                        border: 1px solid #004bb4;
                        border-radius: 5px;
                        box-sizing: border-box;
                        overflow: hidden;
                        overflow-y: auto;
                        text-align: center;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }
                }
                .optionLeft::after,
                .optionRight::after{
                    height: 0;
                    content: '';
                    display: block;
                    overflow: hidden;
                    clear: both;
                }
            }
        }
        .isYImg{
            height: calc(100% - 20%);
        }
        .isYAudio{
            height: calc(100% - 55px);
        }
    }
</style>
<style>
    .optionsHaveValue .jtk-droppable{
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/components/exam/connectionLine91.vue